import {
    SET_DATA_REWARD_LIST,
    SET_DATA_REWARD_LIST_TODAY,
    SET_DATA_REWARD_CODE
} from "@core/redux/actions/lottery/reward";

const initialState = {
    result: null,
    resultToday: null,
    code: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_DATA_REWARD_LIST:
            return { ...state, result: action.payload.items };
        case SET_DATA_REWARD_LIST_TODAY:
            return { ...state, resultToday: action.payload.items };
        case SET_DATA_REWARD_CODE:
            return { ...state, code: action.payload.items };
        default:
            return state;
    }
}